<template>
  <div class="digitalscreen">
    <adx-sidebar />
    <div class="container-router">
      <!-- Hidden for a while until other channel ready. -->
      <!-- <adx-sub-menubar :listUrl="subMenuList" /> -->
      <adx-jumbotron
      :image="jumbotronImg"
      :image-mobile="jumbotronImgMobile"
      :title="'Digital screen'" />
      <p class="jumbotronText subheader-text">Di zaman digital sekarang, cara menarik perhatian seseorang adalah melalui layar. Pasang iklan Anda di layar digital pilihan ADX yang tersebar di seluruh Indonesia.</p>
      <div class="digitalscreen__collections">
        <h2 class="digitalscreen__collections__subtitle small-title">Browse Our Categories</h2>
        <p class="digitalscreen__collections__detail">Iklankan bisnis Anda di waktu dan lokasi yang tepat. </p>
        <div class="digitalscreen__collections__cards">
          <div :class="['digitalscreen__collections__cards__left', {active: showMore}]">
            <adx-category-card v-for="(category, index) in categoriesLeft"
            :key="index"
            :title="category.title"
            :image="category.img"
            :color="category.color"
            :description="category.description"
            :link="category.link"
            :pathName="category.pathName"
            :isDisable="category.disable" />
          </div>
          <!-- <div :class="['digitalscreen__collections__cards__right', {active: showMore}]">
            <adx-category-card v-for="(category, index) in categoriesRight"
            :key="index"
            :title="category.title"
            :image="category.img"
            :color="category.color"
            :description="category.description"
            :link="category.link"
            :pathName="category.pathName"
            :isDisable="category.disable" />
          </div> -->
        </div>
        <div class="digitalscreen__all_categories__block">
          <button type="button" class="btn-block secondary" @click.stop="toggleMore()">{{btnCategoryText}}</button>
        </div>
        <div class="digitalscreen__all_categories__normal">
          <button type="button" class="btn-regular secondary" @click.stop="toggleMore()">{{btnCategoryText}}</button>
        </div>
      </div>
      <div v-if="isLoadingCol">
        <adx-loading />
      </div>
      <div v-else v-for="(group, index) in collectionGroups" :key="index"
        class="digitalscreen__collections">
        <div class="digitalscreen__collections__title">
          <h2 class="digitalscreen__collections__title__subtitle small-title">{{group.title}}</h2>
          <button class="link desktop" @click.stop="allCollection(group.id)">See all <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
        </div>
        <p v-if="group.description" class="digitalscreen__collections__detail">{{group.description}}</p>
        <div v-if="isLoadingCol" class="package-wrapper-load">
          <adx-loading />
        </div>
        <div v-else>
          <adx-card-slider
          :data="group.list"
          :slide="group.layout_id === 'FE' ? 2 : 6"
          :slideMobile="group.layout_id === 'FE' ? 1 : 2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import SubMenuBar from '@/components/SubMenuBar'
import Jumbotron from '@/components/Jumbotron/Category'
import CategoryCard from '@/components/Card/CategoryCard'
import CardSlider from '@/components/Slider/CardSlider'
import Media from "vue-media"
import Loading from '@/components/Loading/Primary'
import api from '@/api/'
import { apiV2 } from '@/api/urls'

export default {
  name: "adx-digital-screens",
  components: {
    "adx-jumbotron": Jumbotron,
    "adx-sidebar": SideBar,
    "adx-category-card": CategoryCard,
    "adx-card-slider": CardSlider,
    "adx-sub-menubar": SubMenuBar,
    'adx-loading': Loading,
    "media": Media,
  },
  head: {
    title: {
      inner: 'Digital Screen',
    }
  },
  created() {
    let file = `/static/data/menus.json`;
    (async () => {
      let request = await fetch(new Request(file));
      let data = await request.json();

      this.subMenuList = data.channels;
    })();
    this.getCollections()
  },
  data() {
    return {
      jumbotronImg: '/img/category/digitalscreen.jpg',
      jumbotronImgMobile: '/img/category/digitalscreen_mobile.jpg',
      showMore: false,
      subMenuList: [],
      isLoadingCol: true,
      collectionTitle: '',
      collectionDesc: '',
      categoriesLeft: [
        {
          title: 'SPBU',
          img: '/img/category/spbu.jpg',
          color: '#ff3b30',
          description: 'ADX bisa bantu Anda beriklan di 102 outlets tempat teramai di Indonesia.',
          link: 'spbu'
        },
        {
          title: 'Malls',
          img: '/img/category/mall.jpg',
          color: '#ff9500',
          description: 'ADX menyediakan space iklan untuk Anda di tempat hangout paling ramai di Jakarta.',
          link: 'malls'
        },
        {
          title: 'Lifestyle',
          img: '/img/category/lifestyle.jpg',
          color: '#5ac8fa',
          description: 'Temui pelanggan baru Anda di tempat-tempat hangout favorit mereka dengan bantuan ADX.',
          link: 'lifestyle'
        },
        {
          title: 'Airport',
          img: '/img/category/airport.jpg',
          color: '#4cd964',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
          link: 'airport'
        }
      ],
      // categoriesRight: [
      //   {
      //     title: 'InFlight',
      //     img: '/img/category/flight.jpg',
      //     color: '#007aff',
      //     description: 'Bawa iklan Anda keliling dunia dengan brand premium Indonesia.',
      //     pathName: '/channel/inflight'
      //   },
      //   {
      //     title: 'Videotron',
      //     img: '/img/category/videotron.jpg',
      //     color: '#ffcc00',
      //     description: 'Jangkau ribuan orang dengan layar digital di lokasi strategis ibu kota.',
      //     pathName: '/channel/videotron'
      //   },
      //   {
      //     title: 'Cinema',
      //     img: '/img/category/cinema.jpg',
      //     color: '#d156d6',
      //     description: 'Jadikan iklan lebih berkesan lewat layar lebar.',
      //     pathName: '/channel/cinema'
      //   },
      // ],
      collectionsSlider: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        }
      ],
      collectionGroups: []
    }
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore
    },
    getCollections() {
      (async () => {
        this.isLoadingCol = true
        const { data } = await api.get(apiV2.collectionAdvertiserList('digitalscreen'), { needToken: false })
        this.collectionGroups = data.data.map(col => {
          return {
            ...col,
            list: col.list.map(item => {
              return {
                ...item,
                img: col.layout_id == 'RE' ? item.square_thumbnail : item.landscape_thumbnail
              }
            })
          }
        })
        this.isLoadingCol = false
      })();
    },
    allCollection(id) {
      this.$router.push({ name: 'collectioncategory', params: { category: id } })
    }
  },
  computed: {
    btnCategoryText() {
      return (this.showMore ? 'View Less' : 'View More')
    }
  }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>
